export default "__VITE_ASSET__ce3b4f4e__"